var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',{attrs:{"label":_vm.$t('Should be added by default')},model:{value:(_vm.includeByDefault),callback:function ($$v) {_vm.includeByDefault=$$v},expression:"includeByDefault"}})}
var staticRenderFns = []

export { render, staticRenderFns }